<template>
  <div class="wrapper">
    <Menu />
    <Header title="Yardım" hideMore />
    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12" v-for="(item, index) in data" :key="index + '-' + item.open">
            <div class="card box-one mt-2 help-box">
              <div class="card-header pt-3 p-2 pb-3" @click="toggle(index)">
                <div class="row ml-0 mr-0">
                  <div class="col-10">
                    <span class="fs-14 fc-2">{{item.question}}</span>
                  </div>
                  <div class="col-2 text-right">
                    <img src="static/img/down-arrow.svg" :class="item.open ? 'd-none' : 'd-inline'" />
                    <img src="static/img/up-arrow.svg" :class="item.open ? 'd-inline' : 'd-none'" />
                  </div>
                </div>
              </div>
              <div class="card-body" :class="item.open ? '' : 'd-none'">
                <div class="row ml-0 mr-0 p-2 pb-3">
                  <div class="col-11">
                    <p>{{item.answer}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "Help",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      data: []
    };
  },
  beforeMount() {
    axios.post("statik/sss").then(res => {
      var x = res.data.pwa == undefined ? res.data.android : res.data.pwa;

      x.map((item, index) => {
        x[index].open = index == 0 ? true : false;
      });

      this.data = x;
    });
  },
  methods: {
    toggle(index) {
      this.data[index].open = !this.data[index].open;
    }
  }
};
</script>

<style>
.opened {
  height: auto !important;
  transition: 1s;
}
</style>


// WEBPACK FOOTER //
// src/pages/Help.vue